import React from 'react';
import clsx from 'clsx';
import styles from './Price.module.scss';
import { SubscriptionPeriod } from 'containers/Subscription/types';

type PriceProps = {
    month: number | string;
    annual?: number | string;
    period?: SubscriptionPeriod;
};

export const Price: React.FC<PriceProps> = ({
    month,
    annual = undefined,
    period,
}: PriceProps): JSX.Element => {
    const classes = clsx(styles.wrap, {
        [styles.annual]: period === 'year',
    });
    const classesFree = clsx(styles.wrap);

    return (
        <div className={annual ? classes : classesFree}>
            <p>{month}</p>
            {annual && <p>{annual}</p>}
        </div>
    );
};
